import * as i0 from '@angular/core';
import { forwardRef, Directive, Pipe, Injectable, Optional, Inject, Input, NgModule } from '@angular/core';
import { Validators, NG_VALIDATORS, NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { utilsBr, validateBr, maskBr } from 'js-brasil';
import { ɵgetDOM, BrowserModule } from '@angular/platform-browser';
import * as textMask from 'text-mask-core';

const cpf = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.cpf(v) ? null : { cpf: true };
};

const CPF_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CPFValidator),
    multi: true
};
class CPFValidator {
    validate(c) {
        return cpf(c);
    }
}
CPFValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CPFValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CPFValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: CPFValidator, selector: "[cpf][formControlName],[cpf][formControl],[cpf][ngModel]", providers: [CPF_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CPFValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cpf][formControlName],[cpf][formControl],[cpf][ngModel]',
                    providers: [CPF_VALIDATOR]
                }]
        }] });

class CPFPipe {
    transform(cpfValue) {
        return maskBr.cpf(cpfValue);
    }
}
CPFPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CPFPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CPFPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CPFPipe, name: "cpf" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CPFPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cpf',
                }]
        }] });

const cnpj = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.cnpj(v) ? null : { cnpj: true };
};

const CNPJ_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CNPJValidator),
    multi: true
};
class CNPJValidator {
    validate(c) {
        return cnpj(c);
    }
}
CNPJValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CNPJValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CNPJValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: CNPJValidator, selector: "[cnpj][formControlName],[cnpj][formControl],[cnpj][ngModel]", providers: [CNPJ_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CNPJValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cnpj][formControlName],[cnpj][formControl],[cnpj][ngModel]',
                    providers: [CNPJ_VALIDATOR]
                }]
        }] });

class CNPJPipe {
    transform(cnpjValue) {
        return maskBr.cnpj(cnpjValue);
    }
}
CNPJPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CNPJPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CNPJPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CNPJPipe, name: "cnpj" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CNPJPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cnpj',
                }]
        }] });

const telefone = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.telefone(v) ? null : { telefone: true };
};

const TELEFONE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => TelefoneValidator),
    multi: true
};
class TelefoneValidator {
    validate(c) {
        return telefone(c);
    }
}
TelefoneValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TelefoneValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TelefoneValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: TelefoneValidator, selector: "[telefone][formControlName],[telefone][formControl],[telefone][ngModel]", providers: [TELEFONE_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TelefoneValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[telefone][formControlName],[telefone][formControl],[telefone][ngModel]',
                    providers: [TELEFONE_VALIDATOR]
                }]
        }] });

class TelefonePipe {
    transform(telefoneValue) {
        return maskBr.telefone(telefoneValue);
    }
}
TelefonePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TelefonePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TelefonePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TelefonePipe, name: "telefone" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TelefonePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'telefone',
                }]
        }] });

const celular = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.celular(v) ? null : { celular: true };
};

const CELULAR_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CelularValidator),
    multi: true
};
class CelularValidator {
    validate(c) {
        return celular(c);
    }
}
CelularValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CelularValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CelularValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: CelularValidator, selector: "[celular][formControlName],[celular][formControl],[celular][ngModel]", providers: [CELULAR_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CelularValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[celular][formControlName],[celular][formControl],[celular][ngModel]',
                    providers: [CELULAR_VALIDATOR]
                }]
        }] });

class CelularPipe {
    transform(celularValue) {
        return maskBr.celular(celularValue);
    }
}
CelularPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CelularPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CelularPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CelularPipe, name: "celular" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CelularPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'celular',
                }]
        }] });

const inscricaoestadual = (estado) => {
    return (control) => {
        if (utilsBr.isPresent(Validators.required(control))) {
            return null;
        }
        const v = control.value;
        return validateBr.inscricaoestadual(v, estado) ? null : { inscricaoestadual: true };
    };
};

const INSCRICAOESTADUAL_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => InscricaoEstadualValidator),
    multi: true
};
class InscricaoEstadualValidator {
    validate(c) {
        return inscricaoestadual('mg')(c);
    }
}
InscricaoEstadualValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InscricaoEstadualValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
InscricaoEstadualValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: InscricaoEstadualValidator, selector: "[inscricaoestadual][formControlName],[inscricaoestadual][formControl],[inscricaoestadual][ngModel]", providers: [INSCRICAOESTADUAL_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InscricaoEstadualValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[inscricaoestadual][formControlName],[inscricaoestadual][formControl],[inscricaoestadual][ngModel]',
                    providers: [INSCRICAOESTADUAL_VALIDATOR]
                }]
        }] });

class InscricaoEstadualPipe {
    transform(inscricaoestadualValue, estado) {
        return maskBr.inscricaoestadual(inscricaoestadualValue, estado);
    }
}
InscricaoEstadualPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InscricaoEstadualPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
InscricaoEstadualPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InscricaoEstadualPipe, name: "inscricaoestadual" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: InscricaoEstadualPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'inscricaoestadual',
                }]
        }] });

const cep = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.cep(v) ? null : { cep: true };
};

const CEP_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CEPValidator),
    multi: true
};
class CEPValidator {
    validate(c) {
        return cep(c);
    }
}
CEPValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CEPValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CEPValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: CEPValidator, selector: "[cep][formControlName],[cep][formControl],[cep][ngModel]", providers: [CEP_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CEPValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[cep][formControlName],[cep][formControl],[cep][ngModel]',
                    providers: [CEP_VALIDATOR]
                }]
        }] });

class CEPPipe {
    transform(cepValue) {
        return maskBr.cep(cepValue);
    }
}
CEPPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CEPPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CEPPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CEPPipe, name: "cep" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CEPPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cep',
                }]
        }] });

const currency = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.currency(v) ? null : { currency: true };
};

const CURRENCY_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => CURRENCYValidator),
    multi: true
};
class CURRENCYValidator {
    validate(c) {
        return currency(c);
    }
}
CURRENCYValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CURRENCYValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
CURRENCYValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: CURRENCYValidator, selector: "[currency][formControlName],[currency][formControl],[currency][ngModel]", providers: [CURRENCY_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CURRENCYValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[currency][formControlName],[currency][formControl],[currency][ngModel]',
                    providers: [CURRENCY_VALIDATOR]
                }]
        }] });

class CURRENCYPipe {
    transform(currencyValue, decimalValue) {
        return maskBr.currency(currencyValue, decimalValue);
    }
}
CURRENCYPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CURRENCYPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
CURRENCYPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CURRENCYPipe, name: "currencyBrazil" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CURRENCYPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'currencyBrazil',
                }]
        }] });

const number = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.number(v) ? null : { number: true };
};

const NUMBER_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => NUMBERValidator),
    multi: true
};
class NUMBERValidator {
    validate(c) {
        return number(c);
    }
}
NUMBERValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NUMBERValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
NUMBERValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: NUMBERValidator, selector: "[number][formControlName],[number][formControl],[number][ngModel]", providers: [NUMBER_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NUMBERValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[number][formControlName],[number][formControl],[number][ngModel]',
                    providers: [NUMBER_VALIDATOR]
                }]
        }] });

class NUMBERPipe {
    transform(numberValue, decimalValue) {
        return maskBr.number(numberValue, decimalValue);
    }
}
NUMBERPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NUMBERPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
NUMBERPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NUMBERPipe, name: "numberBrazil" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NUMBERPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'numberBrazil',
                }]
        }] });

const placa = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.placa(v) ? null : { placa: true };
};

const PLACA_VALIDATOR = {
    provide: NG_VALIDATORS,
    /* tslint:disable: no-use-before-declare */
    useExisting: forwardRef(() => PLACAValidator),
    multi: true
};
class PLACAValidator {
    validate(c) {
        return placa(c);
    }
}
PLACAValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PLACAValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PLACAValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: PLACAValidator, selector: "[placa][formControlName],[placa][formControl],[placa][ngModel]", providers: [PLACA_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PLACAValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[placa][formControlName],[placa][formControl],[placa][ngModel]',
                    providers: [PLACA_VALIDATOR]
                }]
        }] });

class PLACAPipe {
    transform(placaValue) {
        return maskBr.placa(placaValue);
    }
}
PLACAPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PLACAPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PLACAPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PLACAPipe, name: "placa" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PLACAPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'placa'
                }]
        }] });

const percentage = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.porcentagem(v) ? null : { percentage: true };
};

const PERCENTAGE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => PERCENTAGEValidator),
    multi: true
};
class PERCENTAGEValidator {
    validate(c) {
        return percentage(c);
    }
}
PERCENTAGEValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PERCENTAGEValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PERCENTAGEValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: PERCENTAGEValidator, selector: "[percentage][formControlName],[percentage][formControl],[percentage][ngModel]", providers: [PERCENTAGE_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PERCENTAGEValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[percentage][formControlName],[percentage][formControl],[percentage][ngModel]',
                    providers: [PERCENTAGE_VALIDATOR]
                }]
        }] });

class PERCENTAGEPipe {
    transform(percentageValue, decimalValue) {
        return maskBr.porcentagem(percentageValue, decimalValue);
    }
}
PERCENTAGEPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PERCENTAGEPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PERCENTAGEPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PERCENTAGEPipe, name: "percentage" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PERCENTAGEPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'percentage',
                }]
        }] });

const renavam = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.renavam(v) ? null : { renavam: true };
};

const RENAVAM_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => RenavamValidator),
    multi: true
};
class RenavamValidator {
    validate(c) {
        return renavam(c);
    }
}
RenavamValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RenavamValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
RenavamValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: RenavamValidator, selector: "[renavam][formControlName],[renavam][formControl],[renavam][ngModel]", providers: [RENAVAM_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RenavamValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[renavam][formControlName],[renavam][formControl],[renavam][ngModel]',
                    providers: [RENAVAM_VALIDATOR]
                }]
        }] });

class RenavamPipe {
    transform(renavamValue) {
        return maskBr.renavam(renavamValue);
    }
}
RenavamPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RenavamPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
RenavamPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RenavamPipe, name: "renavam" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RenavamPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'renavam',
                }]
        }] });

const pispasep = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.pispasep(v) ? null : { pispasep: true };
};

const PISPASE_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => PispasepValidator),
    multi: true
};
class PispasepValidator {
    validate(c) {
        return pispasep(c);
    }
}
PispasepValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PispasepValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
PispasepValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: PispasepValidator, selector: "[pispasep][formControlName],[pispasep][formControl],[pispasep][ngModel]", providers: [PISPASE_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PispasepValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[pispasep][formControlName],[pispasep][formControl],[pispasep][ngModel]',
                    providers: [PISPASE_VALIDATOR]
                }]
        }] });

class PispasepPipe {
    transform(pispasepValue) {
        return maskBr.pispasep(pispasepValue);
    }
}
PispasepPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PispasepPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PispasepPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PispasepPipe, name: "pispasep" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: PispasepPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'pispasep',
                }]
        }] });

const rg = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.rg(v) ? null : { rg: true };
};

const RG_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => RGValidator),
    multi: true
};
class RGValidator {
    validate(c) {
        return rg(c);
    }
}
RGValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RGValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
RGValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: RGValidator, selector: "[rg][formControlName],[rg][formControl],[rg][ngModel]", providers: [RG_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RGValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[rg][formControlName],[rg][formControl],[rg][ngModel]',
                    providers: [RG_VALIDATOR]
                }]
        }] });

class RGPipe {
    transform(rgValue) {
        return maskBr.rg(rgValue);
    }
}
RGPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RGPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
RGPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RGPipe, name: "rg" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: RGPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'rg',
                }]
        }] });

const time = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.time(v) ? null : { time: true };
};

const TIME_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => TIMEValidator),
    multi: true
};
class TIMEValidator {
    validate(c) {
        return time(c);
    }
}
TIMEValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TIMEValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TIMEValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: TIMEValidator, selector: "[time][formControlName],[time][formControl],[time][ngModel]", providers: [TIME_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TIMEValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[time][formControlName],[time][formControl],[time][ngModel]',
                    providers: [TIME_VALIDATOR]
                }]
        }] });

class TIMEPipe {
    transform(timeValue) {
        return maskBr.time(timeValue);
    }
}
TIMEPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TIMEPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TIMEPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TIMEPipe, name: "time" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TIMEPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'time',
                }]
        }] });

const titulo = (control) => {
    if (utilsBr.isPresent(Validators.required(control))) {
        return null;
    }
    const v = control.value;
    return validateBr.titulo(v) ? null : { titulo: true };
};

const TITULO_VALIDATOR = {
    provide: NG_VALIDATORS,
    // tslint:disable-next-line: no-use-before-declare
    useExisting: forwardRef(() => TITULOValidator),
    multi: true
};
class TITULOValidator {
    validate(c) {
        return titulo(c);
    }
}
TITULOValidator.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TITULOValidator, deps: [], target: i0.ɵɵFactoryTarget.Directive });
TITULOValidator.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: TITULOValidator, selector: "[titulo][formControlName],[titulo][formControl],[titulo][ngModel]", providers: [TITULO_VALIDATOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TITULOValidator, decorators: [{
            type: Directive,
            args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: '[titulo][formControlName],[titulo][formControl],[titulo][ngModel]',
                    providers: [TITULO_VALIDATOR]
                }]
        }] });

class TITULOPipe {
    transform(tituloValue) {
        return maskBr.titulo(tituloValue);
    }
}
TITULOPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TITULOPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TITULOPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TITULOPipe, name: "titulo" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TITULOPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'titulo'
                }]
        }] });

const conformToMask = textMask.conformToMask;
const { createTextMaskInputElement } = textMask;
class TextMaskConfig {
}
const MASKEDINPUT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    /* tslint:disable: no-use-before-declare */
    useExisting: forwardRef(() => MaskedInputDirective),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 */
function _isAndroid() {
    const userAgent = ɵgetDOM() ? ɵgetDOM().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
class MaskedInputDirective {
    constructor(rendererFactory, _elementRef, _compositionMode) {
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.textMaskConfig = {
            mask: [],
            guide: true,
            placeholderChar: '_',
            pipe: undefined,
            keepCharPositions: false,
        };
        /** Whether the user is creating a composition string (IME events). */
        this._composing = false;
        this.onChange = (_) => { };
        this.onTouched = () => { };
        this._renderer = rendererFactory.createRenderer(null, null);
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    ngOnChanges(changes) {
        this._setupMask(true);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(this.inputElement.value);
        }
    }
    writeValue(value) {
        this._setupMask();
        // set the initial value for cases where the mask is disabled
        const normalizedValue = value == null ? '' : value;
        this._renderer.setProperty(this.inputElement, 'value', normalizedValue);
        if (this.textMaskInputElement !== undefined) {
            this.textMaskInputElement.update(value);
        }
    }
    registerOnChange(fn) { this.onChange = fn; }
    registerOnTouched(fn) { this.onTouched = fn; }
    setDisabledState(isDisabled) {
        this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    }
    _handleInput(value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this._setupMask();
            if (this.textMaskInputElement !== undefined) {
                this.textMaskInputElement.update(value);
                // get the updated value
                value = this.inputElement.value;
                this.onChange(value);
            }
        }
    }
    _setupMask(create = false) {
        if (!this.inputElement) {
            if (this._elementRef.nativeElement.tagName.toUpperCase() === 'INPUT') {
                // `textMask` directive is used directly on an input element
                this.inputElement = this._elementRef.nativeElement;
            }
            else {
                // `textMask` directive is used on an abstracted input element, `md-input-container`, etc
                this.inputElement = this._elementRef.nativeElement.getElementsByTagName('INPUT')[0];
            }
        }
        if (this.inputElement && create) {
            this.textMaskInputElement = createTextMaskInputElement(Object.assign({ inputElement: this.inputElement }, this.textMaskConfig));
        }
    }
    _compositionStart() { this._composing = true; }
    _compositionEnd(value) {
        this._composing = false;
        if (this._compositionMode) {
            this._handleInput(value);
        }
    }
}
MaskedInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MaskedInputDirective, deps: [{ token: i0.RendererFactory2 }, { token: i0.ElementRef }, { token: COMPOSITION_BUFFER_MODE, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
MaskedInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: MaskedInputDirective, selector: "[textMask]", inputs: { textMaskConfig: ["textMask", "textMaskConfig"] }, host: { listeners: { "input": "_handleInput($event.target.value)", "blur": "onTouched()", "compositionstart": "_compositionStart()", "compositionend": "_compositionEnd($event.target.value)" } }, providers: [MASKEDINPUT_VALUE_ACCESSOR], exportAs: ["textMask"], usesOnChanges: true, ngImport: i0 });
MaskedInputDirective.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MaskedInputDirective });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MaskedInputDirective, decorators: [{
            type: Injectable
        }, {
            type: Directive,
            args: [{
                    host: {
                        '(input)': '_handleInput($event.target.value)',
                        '(blur)': 'onTouched()',
                        '(compositionstart)': '_compositionStart()',
                        '(compositionend)': '_compositionEnd($event.target.value)'
                    },
                    /* tslint:disable: directive-selector */
                    selector: '[textMask]',
                    exportAs: 'textMask',
                    providers: [MASKEDINPUT_VALUE_ACCESSOR]
                }]
        }], ctorParameters: function () {
        return [{ type: i0.RendererFactory2 }, { type: i0.ElementRef }, { type: undefined, decorators: [{
                        type: Optional
                    }, {
                        type: Inject,
                        args: [COMPOSITION_BUFFER_MODE]
                    }] }];
    }, propDecorators: { textMaskConfig: [{
                type: Input,
                args: ['textMask']
            }] } });
class TextMaskModule {
}
TextMaskModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TextMaskModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TextMaskModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TextMaskModule, declarations: [MaskedInputDirective], imports: [BrowserModule], exports: [MaskedInputDirective] });
TextMaskModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TextMaskModule, imports: [[
            BrowserModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: TextMaskModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        BrowserModule
                    ],
                    declarations: [MaskedInputDirective],
                    exports: [MaskedInputDirective]
                }]
        }] });

const TextMask = {
    TextMaskModule
};
const NgBrazilValidators = {
    cpf,
    cnpj,
    celular,
    cep,
    currency,
    inscricaoestadual,
    number,
    pispasep,
    placa,
    percentage,
    renavam,
    rg,
    telefone,
    time,
    titulo
};
const MASKS = utilsBr.MASKS;
const CustomDirectives = [
    CelularValidator,
    CelularPipe,
    CEPValidator,
    CEPPipe,
    CPFValidator,
    CPFPipe,
    CNPJValidator,
    CNPJPipe,
    CURRENCYValidator,
    CURRENCYPipe,
    InscricaoEstadualValidator,
    InscricaoEstadualPipe,
    NUMBERValidator,
    NUMBERPipe,
    PERCENTAGEValidator,
    PERCENTAGEPipe,
    PispasepValidator,
    PispasepPipe,
    PLACAValidator,
    PLACAPipe,
    RenavamValidator,
    RenavamPipe,
    RGValidator,
    RGPipe,
    TelefoneValidator,
    TelefonePipe,
    TIMEValidator,
    TIMEPipe,
    TITULOValidator,
    TITULOPipe
];
const NgBrDirectives = {
    CelularValidator,
    CelularPipe,
    CEPValidator,
    CEPPipe,
    CNPJValidator,
    CNPJPipe,
    CPFValidator,
    CPFPipe,
    CURRENCYValidator,
    CURRENCYPipe,
    InscricaoEstadualValidator,
    InscricaoEstadualPipe,
    NUMBERValidator,
    NUMBERPipe,
    PERCENTAGEValidator,
    PERCENTAGEPipe,
    PispasepValidator,
    PispasepPipe,
    PLACAValidator,
    PLACAPipe,
    RGValidator,
    RGPipe,
    RenavamValidator,
    RenavamPipe,
    TelefoneValidator,
    TelefonePipe,
    TIMEValidator,
    TIMEPipe,
    TITULOValidator,
    TITULOPipe
};
class NgBrazil {
    static forRoot() {
        return {
            ngModule: NgBrazil
        };
    }
}
NgBrazil.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgBrazil, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NgBrazil.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgBrazil, declarations: [CelularValidator,
        CelularPipe,
        CEPValidator,
        CEPPipe,
        CPFValidator,
        CPFPipe,
        CNPJValidator,
        CNPJPipe,
        CURRENCYValidator,
        CURRENCYPipe,
        InscricaoEstadualValidator,
        InscricaoEstadualPipe,
        NUMBERValidator,
        NUMBERPipe,
        PERCENTAGEValidator,
        PERCENTAGEPipe,
        PispasepValidator,
        PispasepPipe,
        PLACAValidator,
        PLACAPipe,
        RenavamValidator,
        RenavamPipe,
        RGValidator,
        RGPipe,
        TelefoneValidator,
        TelefonePipe,
        TIMEValidator,
        TIMEPipe,
        TITULOValidator,
        TITULOPipe], imports: [FormsModule,
        ReactiveFormsModule], exports: [CelularValidator,
        CelularPipe,
        CEPValidator,
        CEPPipe,
        CPFValidator,
        CPFPipe,
        CNPJValidator,
        CNPJPipe,
        CURRENCYValidator,
        CURRENCYPipe,
        InscricaoEstadualValidator,
        InscricaoEstadualPipe,
        NUMBERValidator,
        NUMBERPipe,
        PERCENTAGEValidator,
        PERCENTAGEPipe,
        PispasepValidator,
        PispasepPipe,
        PLACAValidator,
        PLACAPipe,
        RenavamValidator,
        RenavamPipe,
        RGValidator,
        RGPipe,
        TelefoneValidator,
        TelefonePipe,
        TIMEValidator,
        TIMEPipe,
        TITULOValidator,
        TITULOPipe, FormsModule, ReactiveFormsModule] });
NgBrazil.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgBrazil, imports: [[
            FormsModule,
            ReactiveFormsModule
        ], FormsModule, ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: NgBrazil, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    declarations: [
                        CustomDirectives
                    ],
                    exports: [
                        CustomDirectives, FormsModule, ReactiveFormsModule
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CEPPipe, CEPValidator, CNPJPipe, CNPJValidator, CPFPipe, CPFValidator, CURRENCYPipe, CURRENCYValidator, CelularPipe, CelularValidator, CustomDirectives, InscricaoEstadualPipe, InscricaoEstadualValidator, MASKS, NUMBERPipe, NUMBERValidator, NgBrDirectives, NgBrazil, NgBrazilValidators, PERCENTAGEPipe, PERCENTAGEValidator, PLACAPipe, PLACAValidator, PispasepPipe, PispasepValidator, RGPipe, RGValidator, RenavamPipe, RenavamValidator, TIMEPipe, TIMEValidator, TITULOPipe, TITULOValidator, TelefonePipe, TelefoneValidator, TextMask, celular, cep, cnpj, cpf, currency, inscricaoestadual, number, percentage, pispasep, placa, renavam, rg, telefone, time, titulo };
